import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { Link, useLocation } from "react-router-dom";
import * as Template from "../../templates";

export default () => {

  const moduleName = "attributes";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [categoryOptions, setCategoryOptions] = useState([])


  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect( () => {
    dispatch(actions.list("attribute_categories/option"));
  }, [])

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.attributes_destroy, location.search]);

  useEffect(() => {
    if (appReducer.attributes_list != undefined) {
      setRows(appReducer.attributes_list.data)
      setTotalPages(appReducer.attributes_list.count)
    }
    if(appReducer.attribute_categories_option_list != undefined){
      setCategoryOptions(appReducer.attribute_categories_option_list.data)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'انتخابی - آبشاری',
      selector: row => row.option == 'optional' ? `هست` : `نیست`,
    },
    {
      name: 'تعداد مقادیر',
      selector: row => row.attribute_items.length,
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <div className="flex items-center gap-2">
        <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />
        {row.option == 'optional' && <Link className="bg-gray-200 p-2 rounded-md" to={`/attribute_items?category_id=${row.id}`}>
          <svg className=" flex-shrink-0 size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 8H19M8 12H19M8 16H19M5 8V8.00999M5 12V12.01M5 16V16.01" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
        </Link>}
      </div>,
    },
  ];

  return <div>
    <Template.Filter moduleName={moduleName}>
      <Template.Input label="نام" name="name" type="text" />
      <Template.SingleSelect
        placeholder="انتخاب گروه"
        name="category_id"
        withLabel={true}
        options={categoryOptions}
      />
    </Template.Filter>
    <Template.Table count={totalPages} columns={columns} data={rows} />
  </div>

};
